import React from 'react';
import { IconButton } from '@michelin/acid-components';
import CloudDownload from '@material-ui/icons/CloudDownload';
export const ExportButton = (props) => {
    const { onClick, } = props;
    return (React.createElement(IconButton, { size: "medium", onClick: onClick },
        React.createElement(CloudDownload, null)));
};
//# sourceMappingURL=ExportButton.js.map